import React, { useEffect, useState } from 'react'
import { BasicCollapsible, Box, SwanStyleProps } from '@vp/swan'
import { FaqResult } from '../../types/faq.type'
import { parseArticleBody } from '../../utils/articleParser.utils'

interface Props {
  faqResult: FaqResult
}

const FaqCollapsible: React.FC<Props & SwanStyleProps> = ({ faqResult, ...otherProps }) => {
  const [parsedArticleBody, setParsedArticleBody] = useState<React.ReactElement[]>([])

  useEffect(() => {
    const parsed = parseArticleBody(faqResult.answer)
    setParsedArticleBody(parsed)
  }, [faqResult])

  return (
    <BasicCollapsible collapsibleId={`faq-collapsible-${faqResult.id}`} heading={faqResult.question} {...otherProps}>
      <Box className="content text-size-5 article-content">{parsedArticleBody}</Box>
    </BasicCollapsible>
  )
}
export default FaqCollapsible
